import { Button, Col, Typography } from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import { TableColumns } from "../../../../shared/components/ui/Table/types";
import { saucesWarehousesService } from "../../../../shared/services";
import { ISauceWarehouses } from "../../../../redux/@types";
import Table from "../../../../shared/components/ui/Table";
import { decimal } from "../../../../shared/utils/Helper";
import { useParams } from "react-router-dom";
import { useDeleteSauceWarehouse } from "../../hooks/sauceWarehouses/useDeleteProductWarehouse";

const { Title } = Typography;

export const TableSauceWarehouses = () => {
  const {showDeleteConfirm, setTableProps} = useDeleteSauceWarehouse()
  const columns: TableColumns<ISauceWarehouses> = [
    {
      title: "ID",
      width: 1,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Bodega",
      width: 2,
      dataIndex: ['warehouse', 'name'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Estado",
      width: 3,
      dataIndex: "status",
      key: "status",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
              <Title
                style={{
                  marginBottom: "1.5px",
                  color: "white",
                  padding:"6px 20px", 
                  borderRadius: 36,
                  backgroundColor:
                  item.status === "active" ? "#4bd542" : "#ff4d4f",
                }}
                level={5}
              >
                {item.status}
              </Title>
          </Col>
        );
      },
      filters: [
        {
          text: "Activo",
          value: "active",
        },
        {
          text: "Inactivo",
          value: "inactive",
        },
      ],
    },
    {
      title: "Salsa",
      width: 2,
      dataIndex: ['sauce', 'name'],
      key: "id",
      filterType: "text",
    },
    {
      title: "Precio",
      width: 2,
      key: "id",
      render: (item) => (`${decimal(item.sauce.price)}`),
    },
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.warehouse.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ]
  const {sauce_id, warehouse_id} = useParams()
  
  return (
    
    <Table<ISauceWarehouses>
      columns={columns}
      scroll={{}}
      fetchQueryProps={{
        sauce_id,
        warehouse_id,
        $sort: { id: -1 },
      }}
      service={saucesWarehousesService}
      onLoad={setTableProps}
    />
  );
};
